import { FC, useEffect, useState } from 'react';

import { useRouter } from 'next/router';

import styles from './PageLoader.module.scss';

const PageLoader: FC = () => {
  const router = useRouter();
  const [pageLoading, setPageLoading] = useState(false);

  useEffect(() => {
    const handleStart = (url: string) => url !== router.asPath && setPageLoading(true);
    const handleComplete = () => setPageLoading(false);

    router.events.on('routeChangeStart', handleStart);
    router.events.on('routeChangeComplete', handleComplete);
    router.events.on('routeChangeError', handleComplete);

    return () => {
      router.events.off('routeChangeStart', handleStart);
      router.events.off('routeChangeComplete', handleComplete);
      router.events.off('routeChangeError', handleComplete);
    };
  }, []);
  return (
    <>
      {pageLoading && (
        <div className={styles.loading_container}>
          <div className={styles.ball_clip_rotate}>
            <div></div>
          </div>
        </div>
      )}
    </>
  );
};

export default PageLoader;
